<template>
  <div v-if="cardDistributionMessageDisplay" class="hello-card-distribution-message-box">
    <h2 class="hello-card-distribution-message-title">{{ cardDistributionMessageTitle }}</h2>
    <p class="h-label-2">{{ cardDistributionMessageMessage }}</p>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'hello-card-distribution-message-box',
  inheritAttrs: false,
  props: {
    text: {
      type: String,
      default: 'Error message',
    },
  },
  computed: {
    ...mapGetters('ui', ['currentLocale', 'cardDistributionMessageDisplay', 'cardDistributionMessageTitle', 'cardDistributionMessageMessage']),
  },
};
</script>
<style lang="scss" scoped>
.hello-card-distribution-message-box {
  padding: var(--gap) var(--gap-page-side);
  background-color: var(--color-error);
  color: var(--color-ultra-light);

  @media ($xl-min) {
    padding: 30px 32px;
  }
}

.hello-card-distribution-message-title {
  margin-bottom: var(--gap);
}
</style>
